module.exports = __webpack_public_path__ + "img/spy-guide_en.cdb3f281.png";